import { defineStore } from 'pinia';
import app from '@/main.js';

export const useAuditStore = defineStore('audits', {
    state: () => ({
        panelTitle: '',
        panelType: 'perform',
        isPanelVisible: false,
        audit: null,
        auditHistoryVersionKey: 0,
        auditScheduleVersionKey: 0,
        auditTemplateVersionKey: 0,
    }),
    actions: {
        openPanel(type, audit = null) {
            this.panelType = type;
            this.isPanelVisible = true;
            this.audit = audit;

            const router = app.config.globalProperties.$router;
            const currentRoute = router.currentRoute.value;

            if (
                currentRoute.name === 'Audits' &&
                this.panelType == 'viewSummary'
            ) {
                router.push({
                    name: 'Audits',
                    params: { hash: audit?.hash },
                    query: { ...currentRoute.query },
                });
            }

            const titles = {
                viewTemplate: audit?.name ?? 'View Audit',
                performTemplate: 'Perform Audit',
                editTemplate: 'Edit Audit',
                viewSummary: audit?.name ?? 'View Audit',
                editSummary: 'Edit Audit',
                uploadSummary: 'Upload Your Audit',
                schedule: 'Schedule an Audit',
            };

            this.panelTitle = titles[type] || '';
        },

        closePanel() {
            this.panelType = '';
            this.isPanelVisible = false;
            this.audit = null;
            this.panelTitle = '';

            const router = app.config.globalProperties.$router;
            const currentRoute = router.currentRoute.value;

            if (currentRoute.name === 'Audits' && currentRoute.params?.hash) {
                router.push({
                    name: 'Audits',
                    params: { hash: null },
                    query: { ...currentRoute.query },
                });
            }
        },

        incrementAuditHistoryVersionKey() {
            this.auditHistoryVersionKey++;
        },

        incrementAuditScheduleVersionKey() {
            this.auditScheduleVersionKey++;
        },

        incrementAuditTemplateVersionKey() {
            this.auditTemplateVersionKey++;
        },
    },
    getters: {},
});
